import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import ExcelJS from "exceljs";
import { getdetailsById } from "../../../Services/pqr-details-service";
import { getbyprojectno } from "../../../Services/pqr-header-service";
import { fetchImagePreview } from "../../utility/common/TransactionComponents/CommonImages";
import BarLoader from "react-spinners/BarLoader";

const Excel_DownloadPQR_GrooveOverlay = (props) => {
  console.log('=== EXCEL DEBUGGER START ===');
  console.log('EXCEL: Component initialized with props:', props);
  
  const [loading, setLoading] = useState(true);
  const [excelData, setExcelData] = useState({ header: [], details: [], pdfArray: [], imageUrls: {} });

  console.log('EXCEL: Initial state set, loading:', loading);

  const fetchExcelData = async (IddetailPK, IddetailSK) => {
    console.log('EXCEL: fetchExcelData started with:', { IddetailPK, IddetailSK });
    try {
      // Fetch header data
      let reqParam = {
        groovetype: props.rowdata.wld_WPSType,
        pkid: IddetailPK,
        skid: IddetailSK,
      };
      console.log('EXCEL: reqParam:', reqParam);
      const pqrhead = await getbyprojectno(reqParam);
      console.log('EXCEL: getbyprojectno result:', pqrhead);

      // Fetch detail data
      let reqDetailParam = {
        id1: props.rowdata.wld_WPSType,
        id2: IddetailSK,
      };
      console.log('EXCEL: reqDetailParam:', reqDetailParam);
      const result = await getdetailsById(reqDetailParam);
      console.log('EXCEL: getdetailsById result:', result);

      // Sort processes by saved process order before creating PDF array
      const processOrder = pqrhead[0]?.WPSH_PQR_Process;
      let sortedResult = result;
      if (processOrder) {
        const orderList = processOrder.split(",").filter(Boolean);
        sortedResult = orderList
          .map(process => result.find(item => item.PQR_Process === process))
          .filter(Boolean);
        // Append any processes not in the order list (safety net)
        const remaining = result.filter(item => !orderList.includes(item.PQR_Process));
        sortedResult = [...sortedResult, ...remaining];
      }

      // Filter processes based on showreport flag before creating PDF array
      const filteredProcesses = sortedResult.filter(process => process?.showreport === true);
      console.log('EXCEL: Original processes count:', result.length);
      console.log('EXCEL: Filtered processes count:', filteredProcesses.length);
      console.log('EXCEL: Filtered processes:', filteredProcesses.map(p => ({ 
        process: p.PQR_Process, 
        type: p.PQR_Type, 
        showreport: p.showreport 
      })));

      // Fetch images for Groove/Overlay
      const imageUrls = {
        previewUrlgroove1: null,
        previewUrlgroove2: null
      };
      
      const headerData = pqrhead[0];
      let folderpqr = "PQR_GrooveOverlay";
      
      await fetchImagePreview(folderpqr, headerData.Pdf_images?.[0]?.pqr_image1?.[0], (url) => imageUrls.previewUrlgroove1 = url);
      await fetchImagePreview(folderpqr, headerData.Pdf_images?.[1]?.pqr_image2?.[0], (url) => imageUrls.previewUrlgroove2 = url);

      // Use all processes (not just filtered) to maintain column structure
      // showreport flag controls whether values are shown
      const pdfArray = [...pqrhead, ...sortedResult];
      console.log('EXCEL: pdfArray created with ALL processes:', pdfArray);
      console.log('EXCEL: pdfArray.length:', pdfArray.length);
      console.log('EXCEL: pdfArray[4] exists?', !!pdfArray[4]);

      setExcelData({ header: pqrhead, details: filteredProcesses, pdfArray: pdfArray, imageUrls: imageUrls });
      console.log('EXCEL: Excel data set successfully');
    } catch (error) {
      console.error('EXCEL: Error fetching data:', error);
      alert("Failed to fetch data for Excel export");
    }
  };

  // Helper function to convert image URL to base64 for Excel embedding
  const getImageAsBase64 = async (imageUrl) => {
    if (!imageUrl) return null;
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error converting image to base64:', error);
      return null;
    }
  };

  // Embeds groove images into the joints section of the worksheet
  const embedGrooveImages = async (workbook, worksheet, imageUrls, startRow, endRow, fallbackRow) => {
    try {
      if (imageUrls.previewUrlgroove1) {
        const image1Base64 = await getImageAsBase64(imageUrls.previewUrlgroove1);
        if (image1Base64) {
          const imageId1 = workbook.addImage({ base64: image1Base64, extension: 'png' });
          worksheet.addImage(imageId1, {
            tl: { col: 5, row: startRow - 1 },
            ext: { width: 280, height: (endRow - startRow + 1) * 20 }
          });
        }
      }
      if (imageUrls.previewUrlgroove2) {
        const image2Base64 = await getImageAsBase64(imageUrls.previewUrlgroove2);
        if (image2Base64) {
          const imageId2 = workbook.addImage({ base64: image2Base64, extension: 'png' });
          worksheet.addImage(imageId2, {
            tl: { col: 9, row: startRow - 1 },
            ext: { width: 280, height: (endRow - startRow + 1) * 20 }
          });
        }
      }
    } catch (imageError) {
      console.error('Error adding images to Excel:', imageError);
      worksheet.getCell(`F${fallbackRow}`).value = "[Image Area 1]";
      worksheet.getCell(`J${fallbackRow}`).value = "[Image Area 2]";
    }
  };

  useEffect(() => {
    console.log('EXCEL: Initial useEffect triggered with props.rowdata:', props.rowdata);
    fetchExcelData(props?.rowdata?.PK, props?.rowdata?.PQR_RecordNo);
  }, []);

  async function generateExcel() {
    console.log('EXCEL: generateExcel started');
    console.log('EXCEL: excelData at generation time:', excelData);
    
    if (excelData.header.length === 0) {
      console.error('EXCEL: No header data available for Excel generation');
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("PQR Report");
    const headerData = excelData.header[0];
    console.log('EXCEL: headerData:', headerData);
    
    const detailsData = excelData.details;
    console.log('EXCEL: detailsData:', detailsData);
    
    const isOverlay = headerData.wld_WPSType === "Overlay";
    console.log('EXCEL: isOverlay flag:', isOverlay);
    console.log('EXCEL: WPS Type:', headerData.wld_WPSType);

    worksheet.columns = [
      { width: 35 }, // A
      { width: 16 }, // B
      { width: 16 }, // C
      { width: 16 }, // D
      { width: 16 }, // E
      { width: 16 }, // F
      { width: 16 }, // G
      { width: 16 }, // H
      { width: 16 }, // I
      { width: 16 }, // J
      { width: 16 }, // K
      { width: 16 }, // L
      { width: 16 }, // M
    ];
    worksheet.pageSetup = {
      paperSize: 9,
      orientation: 'portrait',
      fitToPage: true,
      fitToWidth: 1,
      fitToHeight: 0,
      margins: { left: 0.4, right: 0.4, top: 0.75, bottom: 0.75, header: 0.3, footer: 0.3 },
    };

    // Title
    const titleRow = worksheet.addRow(["Procedure Qualification Record (PQR)"]);
    worksheet.mergeCells('A1:M1');
    titleRow.getCell(1).font = { bold: true, size: 16 };
    titleRow.getCell(1).alignment = { horizontal: 'center' };

    worksheet.addRow([]); // row 2 empty

    // Header table - rows 3, 4, 5
    const headerRow1 = worksheet.addRow([
      "PQR record number",
      headerData.PQR_RecordNo || "", "",
      "WPS record Number", "", "",
      headerData.PQR_WPS_RecordNo || "", "", "", "", "",
      "Revision: " + (headerData.PQR_WPS_ReviNo || ""), ""
    ]);
    const headerRow2 = worksheet.addRow([
      "Date",
      headerData.PQR_DOB ? new Date(headerData.PQR_DOB).toLocaleDateString('en-GB') : "", "",
      "Company Name", "", "",
      headerData.PQR_CompanyName || "", "", "", "", "",
      "", ""
    ]);
    const headerRow3 = worksheet.addRow([
      "",
      "", "",
      isOverlay ? "Welding standard" : "Reference Code", "", "",
      isOverlay ? (headerData.PQR_WeldingStandard || "") : (headerData.PQR_ReferenceCode || ""), "", "", "", "",
      "", ""
    ]);

    // Merges: B:C value, D:F label, G:K value, L:M revision
    [headerRow1, headerRow2, headerRow3].forEach(row => {
      worksheet.mergeCells(`B${row.number}:C${row.number}`);
      worksheet.mergeCells(`D${row.number}:F${row.number}`);
      worksheet.mergeCells(`G${row.number}:K${row.number}`);
      worksheet.mergeCells(`L${row.number}:M${row.number}`);
    });

    // Styling
    [headerRow1, headerRow2, headerRow3].forEach(row => {
      row.eachCell((cell, colNumber) => {
        if (colNumber === 1 || colNumber === 4) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
          cell.font = { bold: true };
        }
        cell.border = {
          top: { style: 'thin' }, left: { style: 'thin' },
          bottom: { style: 'thin' }, right: { style: 'thin' }
        };
      });
    });

    worksheet.addRow([]); // row 6 empty

    // BASE METALS section
    const baseMetalTitle = worksheet.addRow(["BASE METALS (QW- 403)"]);
    baseMetalTitle.getCell(1).font = { bold: true };
    baseMetalTitle.getCell(1).fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: 'FFE6E6FA' }
    };

    if (isOverlay) {
      // Overlay BASE METALS: A:M only
      // Header: A(empty), B:C(Product Form), D:G(Spec), H(P no), I(G no), J(Size mm), K(Sch), L(Thk mm), M(Dia mm)
      const baseMetalHeader = worksheet.addRow([
        "", "Product Form", "", "Spec.( Type or Grade),UNS#", "", "", "", "P no", "G no", "Size mm", "Sch", "Thk mm", "Dia mm"
      ]);
      const baseMetalRow1 = worksheet.addRow([
        "",
        headerData.PQR_BM_BM_ProductForm || "", "",
        headerData.PQR_BM_BM_Spec || "", "", "", "",
        headerData.PQR_BM_BM_Pno || "",
        headerData.PQR_BM_BM_Gno || "",
        headerData.PQR_BM_BM_Size || "",
        headerData.PQR_BM_BM_Sch || "",
        headerData.PQR_BM_BM_Thk || "",
        headerData.PQR_BM_BM_Dia || ""
      ]);
      const baseMetalRow2 = worksheet.addRow([
        "",
        headerData.PQR_BM_WTBM_ProductForm || "", "",
        headerData.PQR_BM_WTBM_Spec || "", "", "", "",
        headerData.PQR_BM_WTBM_Pno || "",
        headerData.PQR_BM_WTBM_Gno || "",
        headerData.PQR_BM_WTBM_Size || "",
        headerData.PQR_BM_WTBM_Sch || "",
        headerData.PQR_BM_WTBM_Thk || "",
        headerData.PQR_BM_WTBM_Dia || ""
      ]);

      // B:C = Product Form, D:G = Spec, H-M = single cols each
      [baseMetalHeader, baseMetalRow1, baseMetalRow2].forEach(row => {
        worksheet.mergeCells(`B${row.number}:C${row.number}`);
        worksheet.mergeCells(`D${row.number}:G${row.number}`);
      });

      // Merge A9:A10 for "Welded To"
      worksheet.getCell(`A${baseMetalRow1.number}`).value = "Welded To";
      worksheet.getCell(`A${baseMetalRow2.number}`).value = "";
      worksheet.mergeCells(`A${baseMetalRow1.number}:A${baseMetalRow2.number}`);

      [baseMetalHeader, baseMetalRow1, baseMetalRow2].forEach(row => {
        row.eachCell((cell, colNumber) => {
          if (row === baseMetalHeader) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      });
      const weldedToCell = worksheet.getCell(`A${baseMetalRow1.number}`);
      weldedToCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
      weldedToCell.font = { bold: true };
      weldedToCell.alignment = { vertical: 'middle', horizontal: 'center' };

      const notesRow = worksheet.addRow(["Notes", headerData.PQR_BM_BM_Notes || "", "", "", "", "", "", "", "", "", "", "", ""]);
      worksheet.mergeCells(`B${notesRow.number}:M${notesRow.number}`);
      notesRow.eachCell((cell, colNumber) => {
        if (colNumber === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    } else {
      // Groove: B:C(Product Form), D:G(Spec), H:I(P no), J:K(G no), L:M(Thk mm)
      const baseMetalHeader = worksheet.addRow([
        "", "Product Form", "", "Spec.( Type or Grade),UNS#", "", "", "", "P no", "", "G no", "", "Thk mm", ""
      ]);
      const baseMetalRow1 = worksheet.addRow([
        "",
        headerData.PQR_BM_BM_ProductForm || "", "",
        headerData.PQR_BM_BM_Spec || "", "", "", "",
        headerData.PQR_BM_BM_Pno || "", "",
        headerData.PQR_BM_BM_Gno || "", "",
        headerData.PQR_BM_BM_Thk || "", ""
      ]);
      const baseMetalRow2 = worksheet.addRow([
        "",
        headerData.PQR_BM_WTBM_ProductForm || "", "",
        headerData.PQR_BM_WTBM_Spec || "", "", "", "",
        headerData.PQR_BM_WTBM_Pno || "", "",
        headerData.PQR_BM_WTBM_Gno || "", "",
        headerData.PQR_BM_WTBM_Thk || "", ""
      ]);

      [baseMetalHeader, baseMetalRow1, baseMetalRow2].forEach(row => {
        worksheet.mergeCells(`B${row.number}:C${row.number}`);
        worksheet.mergeCells(`D${row.number}:G${row.number}`);
        worksheet.mergeCells(`H${row.number}:I${row.number}`);
        worksheet.mergeCells(`J${row.number}:K${row.number}`);
        worksheet.mergeCells(`L${row.number}:M${row.number}`);
      });

      worksheet.getCell(`A${baseMetalRow1.number}`).value = "Welded To";
      worksheet.getCell(`A${baseMetalRow2.number}`).value = "";
      worksheet.mergeCells(`A${baseMetalRow1.number}:A${baseMetalRow2.number}`);

      [baseMetalHeader, baseMetalRow1, baseMetalRow2].forEach(row => {
        row.eachCell((cell, colNumber) => {
          if (row === baseMetalHeader && colNumber >= 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
            cell.font = { bold: true };
          }
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      });
      const weldedToCell = worksheet.getCell(`A${baseMetalRow1.number}`);
      weldedToCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
      weldedToCell.font = { bold: true };
      weldedToCell.alignment = { vertical: 'middle', horizontal: 'center' };

      const notesRow = worksheet.addRow(["Notes", headerData.PQR_BM_BM_Notes || "", "", "", "", "", "", "", "", "", "", "", ""]);
      worksheet.mergeCells(`B${notesRow.number}:M${notesRow.number}`);
      notesRow.eachCell((cell, colNumber) => {
        if (colNumber === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      const htcRow = worksheet.addRow(["Heat Treatment Condition", headerData.PQR_BM_HeatTreatmentCondition || "", "", "", "", "", "", "", "", "", "", "", ""]);
      worksheet.mergeCells(`B${htcRow.number}:M${htcRow.number}`);
      htcRow.eachCell((cell, colNumber) => {
        if (colNumber === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });
    }

    worksheet.addRow([]); // Empty row

    // POST WELD HEAT TREATMENT section
    const pwhtTitle = worksheet.addRow(["POST WELD HEAT TREATMENT(QW-407)"]);
    pwhtTitle.getCell(1).font = { bold: true };
    pwhtTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    // Layout: A(label), B:D(value), E:F(label), G:I(value), J:K(label), L:M(value)
    // Add empty rows first, then set values explicitly after merging
    const pwhtRow1 = worksheet.addRow(["","","","","","","","","","","","",""]);
    const pwhtRow2 = worksheet.addRow(["","","","","","","","","","","","",""]);
    const pwhtRow3 = worksheet.addRow(["","","","","","","","","","","","",""]);
    const pwhtRow4 = worksheet.addRow(["","","","","","","","","","","","",""]);
    const pwhtRow5 = worksheet.addRow(["","","","","","","","","","","","",""]);

    // Merges first
    [pwhtRow1, pwhtRow2, pwhtRow3].forEach(row => {
      worksheet.mergeCells(`B${row.number}:D${row.number}`);
      worksheet.mergeCells(`E${row.number}:F${row.number}`);
      worksheet.mergeCells(`G${row.number}:I${row.number}`);
      worksheet.mergeCells(`J${row.number}:K${row.number}`);
      worksheet.mergeCells(`L${row.number}:M${row.number}`);
    });
    worksheet.mergeCells(`B${pwhtRow4.number}:M${pwhtRow4.number}`);
    worksheet.mergeCells(`A${pwhtRow5.number}:E${pwhtRow5.number}`);
    worksheet.mergeCells(`F${pwhtRow5.number}:M${pwhtRow5.number}`);

    // Set values after merging (always use top-left cell of each merged range)
    pwhtRow1.getCell(1).value = "Temperature °C";
    pwhtRow1.getCell(2).value = headerData.PQR_PWHeatTre_Temperature || "";
    pwhtRow1.getCell(5).value = "Time Minutes";
    pwhtRow1.getCell(7).value = headerData.PQR_PWHeatTre_Time || "";
    pwhtRow1.getCell(10).value = "Type";
    pwhtRow1.getCell(12).value = headerData.PQR_PWHeatTre_Type || "";

    pwhtRow2.getCell(1).value = "Heating Rate °C/hr";
    pwhtRow2.getCell(2).value = headerData.PQR_PWHeatTre_Heating_Rate || "";
    pwhtRow2.getCell(5).value = "Loading Temp. °C";
    pwhtRow2.getCell(7).value = headerData.PQR_PWHeatTre_Heating_Method || "";

    pwhtRow3.getCell(1).value = "Cooling Rate °C/hr";
    pwhtRow3.getCell(2).value = headerData.PQR_PWHeatTre_Cooling_Rate || "";
    pwhtRow3.getCell(5).value = "Unloading Temp. °C";
    pwhtRow3.getCell(7).value = headerData.PQR_PWHeatTre_Cooling_Method || "";

    pwhtRow4.getCell(1).value = "Notes";
    pwhtRow4.getCell(2).value = headerData.PQR_PWHeatTre_Notes || "";

    pwhtRow5.getCell(1).value = "Preheat maintenance after completion of welding prior to PWHT (QW-406.2)";
    pwhtRow5.getCell(6).value = headerData.PQR_PWHeatTre_Maintenance || "";

    // Style all PWHT rows
    [pwhtRow1, pwhtRow2, pwhtRow3].forEach(row => {
      for (let c = 1; c <= 13; c++) {
        const cell = row.getCell(c);
        if (c === 1 || c === 5 || c === 10) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
          cell.font = { bold: true };
        }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });
    for (let c = 1; c <= 13; c++) {
      const cell = pwhtRow4.getCell(c);
      if (c === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    }
    for (let c = 1; c <= 13; c++) {
      const cell = pwhtRow5.getCell(c);
      if (c === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    }

    worksheet.addRow([]); // Empty row

    // Add JOINTS section for both Groove and Overlay
    if (isOverlay) {
      const jointsTitle = worksheet.addRow(["JOINTS(QW- 402)"]);
      jointsTitle.getCell(1).font = { bold: true };
      jointsTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

      const jointDesignRow = worksheet.addRow(["Joint design", headerData.PQR_JD_JointDesign || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const jointsNotesRow = worksheet.addRow(["Notes", headerData.PQR_JD_Notes || "", "", "", "", "", "", "", "", "", "", "", ""]);

      [jointDesignRow, jointsNotesRow].forEach(row => {
        worksheet.mergeCells(`B${row.number}:E${row.number}`);
        worksheet.mergeCells(`F${row.number}:I${row.number}`);
        worksheet.mergeCells(`J${row.number}:M${row.number}`);
      });

      await embedGrooveImages(workbook, worksheet, excelData.imageUrls, jointDesignRow.number, jointsNotesRow.number, jointDesignRow.number);

      [jointDesignRow, jointsNotesRow].forEach((row, rowIdx) => {
        const jointRows = [jointDesignRow, jointsNotesRow];
        row.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          } else if (colNumber >= 2 && colNumber <= 5) {
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          } else if (colNumber === 6) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            cell.border = { left: { style: 'thin' }, top: rowIdx === 0 ? { style: 'thin' } : {}, bottom: rowIdx === jointRows.length - 1 ? { style: 'thin' } : {}, right: {} };
          } else if (colNumber >= 7 && colNumber <= 9) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            cell.border = { left: {}, right: colNumber === 9 ? { style: 'thin' } : {}, top: rowIdx === 0 ? { style: 'thin' } : {}, bottom: rowIdx === jointRows.length - 1 ? { style: 'thin' } : {} };
          } else if (colNumber === 10) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            cell.border = { left: { style: 'thin' }, top: rowIdx === 0 ? { style: 'thin' } : {}, bottom: rowIdx === jointRows.length - 1 ? { style: 'thin' } : {}, right: {} };
          } else if (colNumber >= 11 && colNumber <= 13) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            cell.border = { left: {}, right: colNumber === 13 ? { style: 'thin' } : {}, top: rowIdx === 0 ? { style: 'thin' } : {}, bottom: rowIdx === jointRows.length - 1 ? { style: 'thin' } : {} };
          }
        });
      });
    } else {
      const jointsTitle = worksheet.addRow(["JOINTS(QW- 402)"]);
      jointsTitle.getCell(1).font = { bold: true };
      jointsTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

      // Full joints section for Groove - updated layout
      const jointDesignRow = worksheet.addRow(["Joint design", headerData.PQR_JD_JointDesign || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const backingRow = worksheet.addRow(["Backing", headerData.PQR_JD_Backing || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const retainersRow = worksheet.addRow(["Retainers", headerData.PQR_JD_Retainers || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const grooveAngleRow = worksheet.addRow(["Groove angle (deg)", headerData.PQR_JD_GrooveAngle || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const rootOpeningRow = worksheet.addRow(["Root opening (mm)", headerData.PQR_JD_RootOpening || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const rootFaceRow = worksheet.addRow(["Root face (mm)", headerData.PQR_JD_RootFace || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const jointsNotesRow = worksheet.addRow(["Notes", headerData.PQR_JD_Notes || "", "", "", "", "", "", "", "", "", "", "", ""]);
      
      // Merge cells for values (B:E) and image areas (F:I and J:M)
      const jointRows = [jointDesignRow, backingRow, retainersRow, grooveAngleRow, rootOpeningRow, rootFaceRow, jointsNotesRow];
      jointRows.forEach(row => {
        worksheet.mergeCells(`B${row.number}:E${row.number}`); // Values span B:E (4 columns)
        worksheet.mergeCells(`F${row.number}:I${row.number}`); // First image area F:I (4 columns)
        worksheet.mergeCells(`J${row.number}:M${row.number}`); // Second image area J:M (4 columns)
      });
      
      // Embed groove images into joints section
      await embedGrooveImages(workbook, worksheet, excelData.imageUrls, jointDesignRow.number, jointsNotesRow.number, jointDesignRow.number);

      // Style all joint rows
      jointRows.forEach((row, rowIdx) => {
        row.eachCell((cell, colNumber) => {
          if (colNumber === 1) {
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
            cell.font = { bold: true };
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          } else if (colNumber >= 2 && colNumber <= 5) {
            // B:E value area
            cell.alignment = { horizontal: 'center', vertical: 'middle' };
            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
          } else if (colNumber === 6) {
            // F — left border of image 1 area, top/bottom only on first/last row
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            cell.border = {
              left: { style: 'thin' },
              top: rowIdx === 0 ? { style: 'thin' } : {},
              bottom: rowIdx === jointRows.length - 1 ? { style: 'thin' } : {},
              right: {}
            };
          } else if (colNumber >= 7 && colNumber <= 9) {
            // G:I — inner image 1 cells, no internal borders
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            cell.border = {
              left: {},
              right: colNumber === 9 ? { style: 'thin' } : {},
              top: rowIdx === 0 ? { style: 'thin' } : {},
              bottom: rowIdx === jointRows.length - 1 ? { style: 'thin' } : {}
            };
          } else if (colNumber === 10) {
            // J — left border of image 2 area
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            cell.border = {
              left: { style: 'thin' },
              top: rowIdx === 0 ? { style: 'thin' } : {},
              bottom: rowIdx === jointRows.length - 1 ? { style: 'thin' } : {},
              right: {}
            };
          } else if (colNumber >= 11 && colNumber <= 13) {
            // K:M — inner image 2 cells
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
            cell.border = {
              left: {},
              right: colNumber === 13 ? { style: 'thin' } : {},
              top: rowIdx === 0 ? { style: 'thin' } : {},
              bottom: rowIdx === jointRows.length - 1 ? { style: 'thin' } : {}
            };
          }
        });
      });


    }

    worksheet.addRow([]); // Empty row

    // WELDING PROCESSES section
    console.log('=== WELDING PROCESS DEBUG START ===');
    console.log('EXCEL: excelData.pdfArray:', excelData.pdfArray);
    console.log('EXCEL: excelData.pdfArray.length:', excelData.pdfArray.length);
    console.log('EXCEL: detailsData:', detailsData);
    console.log('EXCEL: detailsData.length:', detailsData.length);
    console.log('EXCEL: isOverlay:', isOverlay);
    
    excelData.pdfArray.forEach((item, index) => {
      console.log(`EXCEL: pdfArray[${index}]:`, item);
      if (item) {
        console.log(`EXCEL: pdfArray[${index}].PQR_Process_Category:`, item.PQR_Process_Category);
        console.log(`EXCEL: pdfArray[${index}].PQR_Type:`, item.PQR_Type);
        console.log(`EXCEL: pdfArray[${index}].PQR_Layer:`, item.PQR_Layer);
      }
    });
    detailsData.forEach((item, index) => {
      console.log(`EXCEL: detailsData[${index}]:`, item);
      if (item) {
        console.log(`EXCEL: detailsData[${index}].PQR_Process_Category:`, item.PQR_Process_Category);
        console.log(`EXCEL: detailsData[${index}].PQR_Type:`, item.PQR_Type);
        console.log(`EXCEL: detailsData[${index}].PQR_Layer:`, item.PQR_Layer);
      }
    });
    console.log('=== WELDING PROCESS DEBUG END ===');

    const weldingProcessTitle = worksheet.addRow(["WELDING PROCESSES"]);
    weldingProcessTitle.getCell(1).font = { bold: true };
    weldingProcessTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const actualProcessCount = Math.min(excelData.pdfArray.length - 1, 4);
    
    // Overlay: max 2 processes, B:G / H:M (6 cols each)
    // Groove: max 4 processes, B:D / E:G / H:J / K:M (3 cols each)
    const columnSets = isOverlay ? ['B:G', 'H:M'] : ['B:D', 'E:G', 'H:J', 'K:M'];
    const maxProcesses = isOverlay ? Math.min(actualProcessCount, 2) : Math.min(actualProcessCount, 4);
    const emptyCols = isOverlay ? 5 : 2; // extra empty cells per process slot

    // Row 25: blank A + Process 1/2 headers in B:G / H:M
    const processHeaderRow = worksheet.addRow(["", ...Array(maxProcesses).fill(null).flatMap((_, i) => [`Process ${i + 1}`, ...Array(emptyCols).fill("")])  ]);
    // Row 26: "Welding Process & Type" label + values
    const processValueRow = worksheet.addRow(["Welding Process & Type", ...Array(maxProcesses).fill(null).flatMap((_, i) => {
      const process = excelData.pdfArray[i + 1];
      const val = process?.showreport
        ? `${process?.PQR_Process_Category || ""} & ${process?.PQR_Type || ""}`
        : "";
      return [val, ...Array(emptyCols).fill("")];
    })]);

    for (let i = 0; i < maxProcesses; i++) {
      const [sc, ec] = columnSets[i].split(':');
      worksheet.mergeCells(`${sc}${processHeaderRow.number}:${ec}${processHeaderRow.number}`);
      worksheet.mergeCells(`${sc}${processValueRow.number}:${ec}${processValueRow.number}`);
    }

    for (let c = 1; c <= 13; c++) {
      const hCell = processHeaderRow.getCell(c);
      const vCell = processValueRow.getCell(c);
      if (c === 1) {
        vCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        vCell.font = { bold: true };
      } else {
        hCell.font = { bold: true };
      }
      hCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };
      hCell.alignment = { horizontal: 'center', vertical: 'middle' };
      hCell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      vCell.alignment = { horizontal: 'center', vertical: 'middle' };
      vCell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    }

    // Layer row — Overlay only
    if (isOverlay) {
      const layerValueRow = worksheet.addRow(["Layer", ...Array(maxProcesses).fill(null).flatMap((_, i) => {
        const process = excelData.pdfArray[i + 1];
        const val = process?.showreport ? (process?.PQR_Layer || "") : "";
        return [val, ...Array(emptyCols).fill("")];
      })]);
      for (let i = 0; i < maxProcesses; i++) {
        const [sc, ec] = columnSets[i].split(':');
        worksheet.mergeCells(`${sc}${layerValueRow.number}:${ec}${layerValueRow.number}`);
      }
      for (let c = 1; c <= 13; c++) {
        const cell = layerValueRow.getCell(c);
        if (c === 1) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
          cell.font = { bold: true };
        }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    }

    worksheet.addRow([]); // Empty row

    // FILLER METALS section
    console.log('=== FILLER METALS DEBUG START ===');
    const fillerMetalTitle = worksheet.addRow(["FILLER METALS (QW- 404)"]);
    fillerMetalTitle.getCell(1).font = { bold: true };
    fillerMetalTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    if (excelData.pdfArray.length > 1) {
      console.log('EXCEL: Using pdfArray for filler metals, length:', excelData.pdfArray.length);
      const fillerFields = [
        { label: "SFA specification", field: "PQRD_FM_SFA" },
        { label: "AWS Classification", field: "PQRD_FM_Classification" },
        { label: "Filler Metal F No/ Weld Metal A No", field: "PQRD_FM_FNo", secondField: "PQRD_FM_Ano" },
        { label: "Filler metal nominal composition", field: "PQRD_FM_Nominal" },
        { label: "Filler metal trade name", field: "PQRD_FM_TradeName" },
        { label: "Filler metal product form", field: "PQRD_FM_ProductForm" },
        { label: "Deposited thickness (mm)", field: "PQRD_FM_DepositedThickness" },
        { label: "Maximum pass thickness (mm)", field: "PQRD_FM_MaxPassThickness" }
      ];

      if (isOverlay) {
        fillerFields.push({ label: "Weld deposit chemistry", field: "PQRD_FM_WeldDepositChemistry" });
      }

      fillerFields.push(
        { label: "Flux AWS specification & classification", field: "PQRD_FM_FluxAWS" },
        { label: "Flux trade name", field: "PQRD_FM_FluxTradeName" },
        { label: "Flux type", field: "PQRD_FM_FluxType" },
        { label: "Flux from recrushed slag", field: "PQRD_FM_FluxRecrushed" }
      );

      if (isOverlay) {
        fillerFields.push(
          { label: "Flux nominal composition", field: "PQRD_FM_FluxNominalComposition" },
          { label: "Supplemental filler metal & Insert", field: "PQRD_FM_Supplement" },
          { label: "Filler metal others", field: "PQRD_FM_FillerMetalOthers" }
        );
      } else {
        fillerFields.push({ label: "Supplemental filler metal & Insert", field: "PQRD_FM_Supplement" });
      }

      fillerFields.forEach(field => {
        const row = [field.label];
        console.log(`EXCEL: Processing filler field: ${field.label}`);
        for (let i = 1; i <= maxProcesses; i++) {
          const process = excelData.pdfArray[i];
          console.log(`EXCEL: Filler field ${field.label}, pdfArray[${i}]:`, process);
          if (!process?.showreport) {
            row.push("", ...Array(emptyCols).fill(""));
          } else if (field.secondField) {
            const value = `${process[field.field] || ""}/${process[field.secondField] || ""}`;
            console.log(`EXCEL: Filler field ${field.label} combined value:`, value);
            row.push(value, ...Array(emptyCols).fill(""));
          } else {
            const value = process[field.field] || "";
            console.log(`EXCEL: Filler field ${field.label} single value:`, value);
            row.push(value, ...Array(emptyCols).fill(""));
          }
        }
        const excelRow = worksheet.addRow(row);
        for (let i = 0; i < maxProcesses; i++) {
          const [sc, ec] = columnSets[i].split(':');
          worksheet.mergeCells(`${sc}${excelRow.number}:${ec}${excelRow.number}`);
        }
        for (let c = 1; c <= 13; c++) {
          const cell = excelRow.getCell(c);
          if (c === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        }
      });
    }
    console.log('=== FILLER METALS DEBUG END ===');

    worksheet.addRow([]); // Empty row

    // POSITION section
    console.log('=== POSITION DEBUG START ===');
    const positionTitle = worksheet.addRow(["POSITION(QW-405)"]);
    positionTitle.getCell(1).font = { bold: true };
    positionTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const positionFields = [
      { label: "Position of groove", field: "PQRD_Position_PositionofGroove" },
      { label: "Weld progression", field: "PQRD_Position_WeldProgression" }
    ];

    positionFields.forEach(field => {
      console.log(`EXCEL: Processing position field: ${field.label}`);
      const dataRow = [field.label];
      for (let i = 1; i <= maxProcesses; i++) {
        const process = excelData.pdfArray[i];
        const fieldData = process?.[field.field];
        const val = !process?.showreport ? "" : (Array.isArray(fieldData) ? fieldData.join(', ') : (fieldData || ""));
        dataRow.push(val, ...Array(emptyCols).fill(""));
      }
      const excelDataRow = worksheet.addRow(dataRow);
      for (let i = 0; i < maxProcesses; i++) {
        const [sc, ec] = columnSets[i].split(':');
        worksheet.mergeCells(`${sc}${excelDataRow.number}:${ec}${excelDataRow.number}`);
      }
      for (let c = 1; c <= 13; c++) {
        const cell = excelDataRow.getCell(c);
        if (c === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });
    console.log('=== POSITION DEBUG END ===');

    worksheet.addRow([]); // Empty row

    // PREHEAT section
    const preheatTitle = worksheet.addRow(["PREHEAT(QW-406)"]);
    preheatTitle.getCell(1).font = { bold: true };
    preheatTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const preheatFields = [
      { label: "Minimum preheat temperature (°C)", field: "PQRD_Preheat_MinimumPreheatTemp" },
      { label: "Maximum interpass temperature (°C)", field: "PQRD_Preheat_MaximumInterpassTemp" }
    ];

    preheatFields.forEach(field => {
      const row = [field.label];
      for (let i = 1; i <= maxProcesses; i++) {
        row.push(!excelData.pdfArray[i]?.showreport ? "" : (excelData.pdfArray[i][field.field] || ""), ...Array(emptyCols).fill(""));
      }
      const excelRow = worksheet.addRow(row);
      for (let i = 0; i < maxProcesses; i++) {
        const [sc, ec] = columnSets[i].split(':');
        worksheet.mergeCells(`${sc}${excelRow.number}:${ec}${excelRow.number}`);
      }
      for (let c = 1; c <= 13; c++) {
        const cell = excelRow.getCell(c);
        if (c === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });

    worksheet.addRow([]); // Empty row

    // GAS section
    const gasTitle = worksheet.addRow(["GAS(QW- 408)"]);
    gasTitle.getCell(1).font = { bold: true };
    gasTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const gasFields = isOverlay ? [
      { label: "Shielding:Gas(%Comp)&FlowRate(l/min)", field: "PQRD_Gas_ShieldingType", flowField: "PQRD_Gas_ShieldingFlowRate" }
    ] : [
      { label: "Shielding:Gas(%Comp)&FlowRate(l/min)", field: "PQRD_Gas_ShieldingType", flowField: "PQRD_Gas_ShieldingFlowRate" },
      { label: "Trailing:Gas(%Comp)&FlowRate(l/min)", field: "PQRD_Gas_TrailingType", flowField: "PQRD_Gas_TrailingFlowRate" },
      { label: "Backing:Gas(%Comp)&FlowRate(l/min)", field: "PQRD_Gas_BackingType", flowField: "PQRD_Gas_BackingFlowRate" }
    ];

    gasFields.forEach(field => {
      const row = [field.label];
      for (let i = 1; i <= maxProcesses; i++) {
        const p = excelData.pdfArray[i];
        const gasType = p?.showreport ? (p[field.field] || "") : "";
        const flowRate = p?.showreport ? (p[field.flowField] || "") : "";
        row.push(`${gasType}${gasType || flowRate ? ' & ' : ''}${flowRate}`, ...Array(emptyCols).fill(""));
      }
      const excelRow = worksheet.addRow(row);
      for (let i = 0; i < maxProcesses; i++) {
        const [sc, ec] = columnSets[i].split(':');
        worksheet.mergeCells(`${sc}${excelRow.number}:${ec}${excelRow.number}`);
      }
      for (let c = 1; c <= 13; c++) {
        const cell = excelRow.getCell(c);
        if (c === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });

    worksheet.addRow([]); // Empty row

    // ELECTRICAL section
    const electricalTitle = worksheet.addRow(["ELECTRICAL(QW- 409)"]);
    electricalTitle.getCell(1).font = { bold: true };
    electricalTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const electricalFields = isOverlay ? [
      { label: "Filler metal size (mm)", field: "PQRD_Electrical_FillerMetalSize" },
      { label: "Amperes (Amps)", field: "PQRD_Electrical_Amperes" },
      { label: "Volts (Volts)", field: "PQRD_Electrical_Volts" },
      { label: "Travel speed (mm/min)", field: "PQRD_Electrical_TravelSpeed" },
      { label: "Maximum heat input (KJ/mm)", field: "PQRD_Electrical_MaxHeatInput" },
      { label: "Tungsten type & size", field: "PQRD_Electrical_TungstenType" },
      { label: "Current/polarity", field: "PQRD_Electrical_CurrentPolarity" },
      { label: "DC pulsing current", field: "PQRD_Electrical_DCPulsatingCurrent" },
      { label: "Wire Feed Type", field: "PQRD_Electrical_WireFeedType" },
      { label: "Wire Feed Speed (m/min)", field: "PQRD_Electrical_WireFeedSpeed" }
    ] : [
      { label: "Filler metal size(Ø) (mm)", field: "PQRD_Electrical_FillerMetalSize" },
      { label: "Amperes (Amps)", field: "PQRD_Electrical_Amperes" },
      { label: "Voltage (Volts)", field: "PQRD_Electrical_Volts" },
      { label: "Travel speed (mm/min)", field: "PQRD_Electrical_TravelSpeed" },
      { label: "Minimum bead Length (SMAW) (mm)", field: "PQRD_Electrical_minBeadLength" },
      { label: "Arc Transfer Mode (FCAW/GMAW)", field: "PQRD_Electrical_ArcTransferMode" },
      { label: "Maximum heat input (KJ/mm)", field: "PQRD_Electrical_MaxHeatInput" },
      { label: "Tungsten type & size", field: "PQRD_Electrical_TungstenType" },
      { label: "Current/polarity", field: "PQRD_Electrical_CurrentPolarity" },
      { label: "DC pulsing current", field: "PQRD_Electrical_DCPulsatingCurrent" }
    ];

    // Helpers for electrical section — array values spread across individual cells per process
    const colsPerProcess = emptyCols + 1;
    const processStartCols = columnSets.map(cs => cs.charCodeAt(0) - 64);

    const placeValues = (rowData, startCol, fd, isArr) => {
      if (!isArr) { rowData[startCol - 1] = fd || ""; return; }
      if (isOverlay) {
        fd.forEach((val, idx) => { if (idx < 3) rowData[startCol - 1 + idx * 2] = val; });
      } else {
        fd.forEach((val, idx) => { if (idx < colsPerProcess) rowData[startCol - 1 + idx] = val; });
      }
    };

    const applyMerges = (ws, row, fd, colSet, startCol) => {
      if (!Array.isArray(fd)) {
        const [sc, ec] = colSet.split(':');
        ws.mergeCells(`${sc}${row.number}:${ec}${row.number}`);
      } else if (isOverlay) {
        for (let p = 0; p < 3; p++) {
          const c1 = String.fromCharCode(64 + startCol + p * 2);
          const c2 = String.fromCharCode(64 + startCol + p * 2 + 1);
          ws.mergeCells(`${c1}${row.number}:${c2}${row.number}`);
        }
      }
      // Groove array: no merge — each value in its own cell
    };

    const scalarElectricalFields = ["PQRD_Electrical_TungstenType", "PQRD_Electrical_CurrentPolarity"];

    electricalFields.forEach(field => {
      const rowData = Array(13).fill("");
      rowData[0] = field.label;
      for (let i = 0; i < maxProcesses; i++) {
        const p = excelData.pdfArray[i + 1];
        let fd = p?.showreport ? p[field.field] : null;
        // For fields that should always be scalar (joined if array)
        if (Array.isArray(fd) && scalarElectricalFields.includes(field.field)) {
          fd = fd.join(', ');
        }
        placeValues(rowData, processStartCols[i], fd, Array.isArray(fd));
      }
      const excelRow = worksheet.addRow(rowData);
      for (let i = 0; i < maxProcesses; i++) {
        const p = excelData.pdfArray[i + 1];
        let fd = p?.showreport ? p[field.field] : null;
        if (Array.isArray(fd) && scalarElectricalFields.includes(field.field)) {
          fd = fd.join(', ');
        }
        applyMerges(worksheet, excelRow, fd, columnSets[i], processStartCols[i]);
      }
      for (let c = 1; c <= 13; c++) {
        const cell = excelRow.getCell(c);
        if (c === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });

    worksheet.addRow([]); // Empty row

    // TECHNIQUE section
    const techniqueTitle = worksheet.addRow(["TECHNIQUE(QW- 410)"]);
    techniqueTitle.getCell(1).font = { bold: true };
    techniqueTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    const techniqueFields = isOverlay ? [
      { label: "Oscillation", field: "PQRD_Technique_Oscillation" },
      { label: "No. of electrodes on same puddle", field: "PQRD_Technique_ElectrodesSamePuddle" },
      { label: "Multiple or single layer", field: "PQRD_Technique_Multiple_SingleLayer" },
      { label: "Supplemental device", field: "PQRD_Technique_SupplimentalDevice" },
      { label: "Initial/interpass cleaning", field: "PQRD_Technique_InitialInterpassCleaning" },
      { label: "Overlapping", field: "PQRD_Technique_Overlaping" },
      { label: "C.T.W.D (mm)", field: "PQRD_Technique_CTWD" }
    ] : [
      { label: "String or weave", field: "PQRD_Technique_StringOrWeave" },
      { label: "Orifice/gas cup size", field: "PQRD_Technique_Orifice_GasCupSize" },
      { label: "C.T.W.D (mm)", field: "PQRD_Technique_CTWD" },
      { label: "Oscillation", field: "PQRD_Technique_Oscillation" },
      { label: "Multi/Single electrode", field: "PQRD_Technique_Multi_SingleElectrode" },
      { label: "Electrode angle", field: "PQRD_Technique_ElectrodeAngle" },
      { label: "Multi/Single pass per side", field: "PQRD_Technique_SinglePassPerSide" },
      { label: "Multiple or single layer", field: "PQRD_Technique_Multiple_SingleLayer" },
      { label: "Peening", field: "PQRD_Technique_Peening" },
      { label: "Initial/interpass cleaning", field: "PQRD_Technique_InitialInterpassCleaning" },
      { label: "Back gouging method", field: "PQRD_Technique_BackGaugingMethod" },
      { label: "Groove preparation", field: "PQRD_Technique_GroovePreparation" },
      { label: "Technique Others", field: "PQRD_Technique_Technique_Other" }
    ];

    techniqueFields.forEach(field => {
      const row = [field.label];
      for (let i = 1; i <= maxProcesses; i++) {
        row.push(!excelData.pdfArray[i]?.showreport ? "" : (excelData.pdfArray[i][field.field] || ""), ...Array(emptyCols).fill(""));
      }
      const excelRow = worksheet.addRow(row);
      for (let i = 0; i < maxProcesses; i++) {
        const [sc, ec] = columnSets[i].split(':');
        worksheet.mergeCells(`${sc}${excelRow.number}:${ec}${excelRow.number}`);
      }
      for (let c = 1; c <= 13; c++) {
        const cell = excelRow.getCell(c);
        if (c === 1) { cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; cell.font = { bold: true }; }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });

    worksheet.addRow([]); // Empty row

    // Page 2 title
    const page2TitleRow = worksheet.addRow(["=== PAGE 2 PROCESSES ==="]);
    worksheet.mergeCells(`A${page2TitleRow.number}:M${page2TitleRow.number}`);
    page2TitleRow.getCell(1).font = { bold: true };
    page2TitleRow.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFCCCCCC' } };
    page2TitleRow.getCell(1).alignment = { horizontal: 'center' };

    worksheet.addRow([]); // Empty row

    // Add test sections
    console.log('EXCEL: Adding test sections');
    
    // Get dynamic test flags from header data (same as PDF)
    const showTensileTest = headerData?.showTensileTest || false;
    const showGuidedBendTest = headerData?.showGuidedBendTest || false;
    const showOtherTest = headerData?.showOtherTest || false;
    
    console.log('EXCEL: Test flags - Tensile:', showTensileTest, 'GuidedBend:', showGuidedBendTest, 'Other:', showOtherTest);
    
    // TENSILE TEST section (only for Groove, not Overlay, and only if showTensileTest is true)
    if (showTensileTest && !isOverlay) {
      const tensileTestTitle = worksheet.addRow(["TENSILE TEST(QW-150)"]);
      tensileTestTitle.getCell(1).font = { bold: true };
      tensileTestTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

      const tensileTestHeader = worksheet.addRow([
        "Specimen number", "Width mm", "", "Thickness mm", "", "Area mm²", "", 
        "Ultimate load N", "", "Ultimate stress MPa", "", "Type of failure and location", ""
      ]);
      
      // Merge header cells (2 columns each)
      worksheet.mergeCells(`B${tensileTestHeader.number}:C${tensileTestHeader.number}`); // Width mm (B:C)
      worksheet.mergeCells(`D${tensileTestHeader.number}:E${tensileTestHeader.number}`); // Thickness mm (D:E)
      worksheet.mergeCells(`F${tensileTestHeader.number}:G${tensileTestHeader.number}`); // Area mm2 (F:G)
      worksheet.mergeCells(`H${tensileTestHeader.number}:I${tensileTestHeader.number}`); // Ultimate load N (H:I)
      worksheet.mergeCells(`J${tensileTestHeader.number}:K${tensileTestHeader.number}`); // Ultimate stress Mpa (J:K)
      worksheet.mergeCells(`L${tensileTestHeader.number}:M${tensileTestHeader.number}`); // Type of failure and location (L:M)
      
      tensileTestHeader.eachCell((cell) => {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      });

      // Add tensile test data from all pdf elements
      excelData.pdfArray.forEach((pdfItem) => {
        if (pdfItem?.Tensile_Test) {
          pdfItem.Tensile_Test.forEach(item => {
            const row = worksheet.addRow([
              item.PQR_Tensile_SpecimenNo || "",
              item.PQR_Tensile_Width || "", "", // B:C
              item.PQR_Tensile_Thickness || "", "", // D:E
              item.PQR_Tensile_Area || "", "", // F:G
              item.PQR_Tensile_UltimateLoad || "", "", // H:I
              item.PQR_Tensile_UltimateStress || "", "", // J:K
              item.PQR_Tensile_FailureLocation || "", "" // L:M
            ]);
            
            // Merge data cells (2 columns each)
            worksheet.mergeCells(`B${row.number}:C${row.number}`); // Width mm (B:C)
            worksheet.mergeCells(`D${row.number}:E${row.number}`); // Thickness mm (D:E)
            worksheet.mergeCells(`F${row.number}:G${row.number}`); // Area mm2 (F:G)
            worksheet.mergeCells(`H${row.number}:I${row.number}`); // Ultimate load N (H:I)
            worksheet.mergeCells(`J${row.number}:K${row.number}`); // Ultimate stress Mpa (J:K)
            worksheet.mergeCells(`L${row.number}:M${row.number}`); // Type of failure and location (L:M)
            
            row.eachCell((cell) => {
              cell.alignment = { horizontal: 'center', vertical: 'middle' };
              cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            });
          });
        }
      });

      // Tensile Test Remarks and Report Number
      const tensileRemarksRow = worksheet.addRow(["Remarks", headerData.PQR_Tensile_RemarksHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const tensileReportRow = worksheet.addRow(["Report Number", headerData.PQR_Tensile_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
      
      // Merge remarks and report number values (B to M)
      worksheet.mergeCells(`B${tensileRemarksRow.number}:M${tensileRemarksRow.number}`);
      worksheet.mergeCells(`B${tensileReportRow.number}:M${tensileReportRow.number}`);
      
      [tensileRemarksRow, tensileReportRow].forEach(row => {
        row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        row.getCell(1).font = { bold: true };
        row.eachCell((cell) => {
          // cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      });

      worksheet.addRow([]); // Empty row
    }
    
    // GUIDED BEND TEST section (only if showGuidedBendTest is true)
    if (showGuidedBendTest) {
      const guidedBendTitle2 = worksheet.addRow(["GUIDED BEND TEST(QW-160)"]);
      guidedBendTitle2.getCell(1).font = { bold: true };
      guidedBendTitle2.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

      if (isOverlay) {
        // Overlay guided bend test format
        const guidedBendHeader2 = worksheet.addRow([
          "Nos. of specimen", "Thk (mm)", "", "Breadth (mm)", "", "Former Diameter (mm)", "", 
          "Bend Angle (deg)", "", "Acceptance Criteria", "", "Remark", ""
        ]);
        
        // Merge header cells (2 columns each)
        worksheet.mergeCells(`B${guidedBendHeader2.number}:C${guidedBendHeader2.number}`); // Thk (mm) (B:C)
        worksheet.mergeCells(`D${guidedBendHeader2.number}:E${guidedBendHeader2.number}`); // Breadth (mm) (D:E)
        worksheet.mergeCells(`F${guidedBendHeader2.number}:G${guidedBendHeader2.number}`); // Former Diameter (mm) (F:G)
        worksheet.mergeCells(`H${guidedBendHeader2.number}:I${guidedBendHeader2.number}`); // Bend Angle (deg) (H:I)
        worksheet.mergeCells(`J${guidedBendHeader2.number}:K${guidedBendHeader2.number}`); // Acceptance Criteria (J:K)
        worksheet.mergeCells(`L${guidedBendHeader2.number}:M${guidedBendHeader2.number}`); // Remark (L:M)
        
        guidedBendHeader2.eachCell((cell) => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
          cell.font = { bold: true };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        // Add overlay guided bend test data
        excelData.pdfArray.forEach((pdfItem) => {
          if (pdfItem?.GuidedBend_Test_Overlay) {
            pdfItem.GuidedBend_Test_Overlay.forEach(item => {
              const row = worksheet.addRow([
                item.PQR_GBV_SpecimenNo || "",
                item.PQR_GBV_Thickness || "", "", // B:C
                item.PQR_GBV_BM_WeldOverlay || "", "", // D:E
                item.PQR_GBV_FormerDiam || "", "", // F:G
                item.PQR_GBV_BendAngle || "", "", // H:I
                item.PQR_GBV_Acceptance_Criteria || "", "", // J:K
                item.PQR_GBV_Remarks || "", "" // L:M
              ]);
              
              // Merge data cells (2 columns each)
              worksheet.mergeCells(`B${row.number}:C${row.number}`); // Thk (mm) (B:C)
              worksheet.mergeCells(`D${row.number}:E${row.number}`); // Breadth (mm) (D:E)
              worksheet.mergeCells(`F${row.number}:G${row.number}`); // Former Diameter (mm) (F:G)
              worksheet.mergeCells(`H${row.number}:I${row.number}`); // Bend Angle (deg) (H:I)
              worksheet.mergeCells(`J${row.number}:K${row.number}`); // Acceptance Criteria (J:K)
              worksheet.mergeCells(`L${row.number}:M${row.number}`); // Remark (L:M)
              
              row.eachCell((cell) => {
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
              });
            });
          }
        });
        
        // Guided Bend Remarks and Report Number for Overlay (B to M)
        const gbRemarksRow2 = worksheet.addRow(["Remarks", headerData.PQR_GB_RemarksHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
        const gbReportRow2 = worksheet.addRow(["Report Number", headerData.PQR_GB_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
        
        // Merge remarks and report number values (B to M)
        worksheet.mergeCells(`B${gbRemarksRow2.number}:M${gbRemarksRow2.number}`);
        worksheet.mergeCells(`B${gbReportRow2.number}:M${gbReportRow2.number}`);
        
      } else {
        // Groove guided bend test format (only if not overlay)
        const guidedBendHeader2 = worksheet.addRow([
          "Identification", "Thickness (mm)", "", "Width (mm)", "", "Former Mandril Dia (mm)", "",
          "Angle of Bend (\u00b0)", "", "Acceptance Criteria", "", "Results", ""
        ]);
        
        // Merge header cells (2 columns each)
        worksheet.mergeCells(`B${guidedBendHeader2.number}:C${guidedBendHeader2.number}`);
        worksheet.mergeCells(`D${guidedBendHeader2.number}:E${guidedBendHeader2.number}`);
        worksheet.mergeCells(`F${guidedBendHeader2.number}:G${guidedBendHeader2.number}`);
        worksheet.mergeCells(`H${guidedBendHeader2.number}:I${guidedBendHeader2.number}`);
        worksheet.mergeCells(`J${guidedBendHeader2.number}:K${guidedBendHeader2.number}`);
        worksheet.mergeCells(`L${guidedBendHeader2.number}:M${guidedBendHeader2.number}`);
        
        guidedBendHeader2.eachCell((cell) => {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
          cell.font = { bold: true };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });

        // Add groove guided bend test data
        excelData.pdfArray.forEach((pdfItem) => {
          if (pdfItem?.GuidedBend_Test) {
            pdfItem.GuidedBend_Test.forEach(item => {
              const row = worksheet.addRow([
                item.PQR_GB_TypeofTest || "",
                item.PQR_GB_Thickness || "", "",
                item.PQR_GB_Width || "", "",
                item.PQR_GB_FormerMandrilDia || "", "",
                item.PQR_GB_AngleOfBend || "", "",
                item.PQR_GB_Acceptance_Criteria || "", "",
                item.PQR_GB_Results || "", ""
              ]);
              
              worksheet.mergeCells(`B${row.number}:C${row.number}`);
              worksheet.mergeCells(`D${row.number}:E${row.number}`);
              worksheet.mergeCells(`F${row.number}:G${row.number}`);
              worksheet.mergeCells(`H${row.number}:I${row.number}`);
              worksheet.mergeCells(`J${row.number}:K${row.number}`);
              worksheet.mergeCells(`L${row.number}:M${row.number}`);
              
              row.eachCell((cell) => {
                cell.alignment = { horizontal: 'center', vertical: 'middle' };
                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
              });
            });
          }
        });
        
        // Guided Bend Remarks and Report Number for Groove (B to M)
        const gbRemarksRow2 = worksheet.addRow(["Remarks", headerData.PQR_GB_RemarksHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
        const gbReportRow2 = worksheet.addRow(["Report Number", headerData.PQR_GB_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
        
        // Merge remarks and report number values (B to M)
        worksheet.mergeCells(`B${gbRemarksRow2.number}:M${gbRemarksRow2.number}`);
        worksheet.mergeCells(`B${gbReportRow2.number}:M${gbReportRow2.number}`);
      }
      
      // Common styling for both Overlay and Groove Remarks/Report rows
      const gbRemarksRow2 = worksheet.getRow(worksheet.lastRow.number - 1);
      const gbReportRow2 = worksheet.getRow(worksheet.lastRow.number);
      [gbRemarksRow2, gbReportRow2].forEach(row => {
        row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        row.getCell(1).font = { bold: true };
        row.eachCell((cell) => {
          // cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        });
      });

      worksheet.addRow([]); // Empty row
    }
    
    // TOUGHNESS TEST section (only for Groove, not Overlay)
    if (!isOverlay) {
      const toughnessTestTitle = worksheet.addRow(["TOUGHNESS TEST(QW-170)"]);
      toughnessTestTitle.getCell(1).font = { bold: true };
      toughnessTestTitle.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

      // Top-level group header row: A:D=Impact Test, E:F=Charpy V Notch, G=Specimen Size in mm, I:M=dimension value
      const toughnessGroupHeader = worksheet.addRow([
        "Impact Test", "", "", "", "Charpy V Notch", "", "Specimen Size in mm", "", headerData.PQR_TT_SpecimenSize_Dimension || "", "", "", "", ""
      ]);
      worksheet.mergeCells(`A${toughnessGroupHeader.number}:D${toughnessGroupHeader.number}`);
      worksheet.mergeCells(`E${toughnessGroupHeader.number}:F${toughnessGroupHeader.number}`);
      worksheet.mergeCells(`I${toughnessGroupHeader.number}:M${toughnessGroupHeader.number}`);
      for (let c = 1; c <= 13; c++) {
        const cell = toughnessGroupHeader.getCell(c);
        if (c !== 9) cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }

      // Header row: A:C=Location of Specimen, D=Welding Process, E=Notch Location, F=Test temp, G:M=Impact Values
      const toughnessTestHeader = worksheet.addRow([
        "Location of Specimen", "", "", "Welding Process", "Notch Location",
        "Test temp °C", "Impact Values", "", "", "", "", "", ""
      ]);
      worksheet.mergeCells(`G${toughnessTestHeader.number}:M${toughnessTestHeader.number}`);

      // Sub-header row: A:C=Location (vertical merge), D=Welding Process (vertical), E=Notch (vertical), F=Test temp (vertical), G:H=Impact Value, I=Avg, J:K=Lateral, L:M=Shear
      const toughnessSubHeader = worksheet.addRow([
        "", "", "", "", "", "",
        "Impact Value (J)", "", "Avg. (J)", "Lateral Expansion (mm)", "", "% Shear Fracture", ""
      ]);
      worksheet.mergeCells(`G${toughnessSubHeader.number}:H${toughnessSubHeader.number}`);
      worksheet.mergeCells(`J${toughnessSubHeader.number}:K${toughnessSubHeader.number}`);
      worksheet.mergeCells(`L${toughnessSubHeader.number}:M${toughnessSubHeader.number}`);

      // Vertical merges for A:C, D, E, F across header and sub-header
      worksheet.mergeCells(`A${toughnessTestHeader.number}:C${toughnessSubHeader.number}`);
      worksheet.mergeCells(`D${toughnessTestHeader.number}:D${toughnessSubHeader.number}`);
      worksheet.mergeCells(`E${toughnessTestHeader.number}:E${toughnessSubHeader.number}`);
      worksheet.mergeCells(`F${toughnessTestHeader.number}:F${toughnessSubHeader.number}`);

      [toughnessTestHeader, toughnessSubHeader].forEach(row => {
        for (let c = 1; c <= 13; c++) {
          const cell = row.getCell(c);
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
          cell.font = { bold: true };
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        }
      });

      // Add toughness test data: A:C=SpecimenNo, D=WeldingProcess, E=NotchLocation, F=TestTemp, G:H=ImpactValues, I=Avg, J:K=LateralExpansion, L:M=Shear
      excelData.pdfArray.forEach((pdfItem) => {
        if (pdfItem?.Toughness_Test) {
          pdfItem.Toughness_Test.forEach(item => {
            const row = worksheet.addRow([
              item.PQR_TT_SpecimenNo || "", "", "",
              item.PQR_TT_WeldingProcess || "",
              item.PQR_TT_NotchLocation || "",
              item.PQR_TT_TestTemp || "",
              item.PQR_TT_ImpactValues || "", "",
              item.PQR_TT_Avg || "",
              item.PQR_TT_LateralExpansion || "", "",
              item.PQR_TT_Shear || "", ""
            ]);
            worksheet.mergeCells(`A${row.number}:C${row.number}`);
            worksheet.mergeCells(`G${row.number}:H${row.number}`);
            worksheet.mergeCells(`J${row.number}:K${row.number}`);
            worksheet.mergeCells(`L${row.number}:M${row.number}`);
            for (let c = 1; c <= 13; c++) {
              row.getCell(c).alignment = { horizontal: 'center', vertical: 'middle' };
              row.getCell(c).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            }
          });
        }
      });

      // Toughness Test Remarks and Report Number (B:M)
      const toughnessRemarksRow = worksheet.addRow(["Remarks", headerData.PQR_TT_RemarksHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const toughnessReportRow = worksheet.addRow(["Report Number", headerData.PQR_TT_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
      worksheet.mergeCells(`B${toughnessRemarksRow.number}:M${toughnessRemarksRow.number}`);
      worksheet.mergeCells(`B${toughnessReportRow.number}:M${toughnessReportRow.number}`);
      [toughnessRemarksRow, toughnessReportRow].forEach(row => {
        row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        row.getCell(1).font = { bold: true };
        for (let c = 1; c <= 13; c++) {
          row.getCell(c).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        }
      });

      worksheet.addRow([]); // Empty row
    }
    
    // OTHER TEST section (only if showOtherTest is true)
    if (showOtherTest) {
      const otherTestTitle2 = worksheet.addRow(["OTHER TEST", "", "", "", "", "", "", "", "", "", "", "", ""]);
      worksheet.mergeCells(`A${otherTestTitle2.number}:M${otherTestTitle2.number}`);
      otherTestTitle2.getCell(1).font = { bold: true };
      otherTestTitle2.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

      // Reference: A:D=Type of test, E:F=Acceptance criteria, G:H=Result, I:M=Remarks
      const otherTestHeader2 = worksheet.addRow([
        "Type of test", "", "", "", "Acceptance criteria", "", "Result", "", "Remarks", "", "", "", ""
      ]);
      worksheet.mergeCells(`A${otherTestHeader2.number}:D${otherTestHeader2.number}`);
      worksheet.mergeCells(`E${otherTestHeader2.number}:F${otherTestHeader2.number}`);
      worksheet.mergeCells(`G${otherTestHeader2.number}:H${otherTestHeader2.number}`);
      worksheet.mergeCells(`I${otherTestHeader2.number}:M${otherTestHeader2.number}`);
      for (let c = 1; c <= 13; c++) {
        const cell = otherTestHeader2.getCell(c);
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        cell.font = { bold: true };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }

      // Add other test data — check both headerData and pdfArray items
      console.log('EXCEL: Other_Test on headerData:', headerData?.Other_Test);
      excelData.pdfArray.forEach((pdfItem, idx) => {
        console.log(`EXCEL: pdfArray[${idx}].Other_Test:`, pdfItem?.Other_Test);
      });
      const otherTestSource = headerData?.Other_Test ? [headerData] : excelData.pdfArray;
      otherTestSource.forEach((pdfItem) => {
        if (pdfItem?.Other_Test) {
          pdfItem.Other_Test.forEach(item => {
            const row = worksheet.addRow([
              item.PQR_OT_TypeofTest || "", "", "", "", // A:D
              item.PQR_OT_Acceptance_Criteria || "", "", // E:F
              item.PQR_OT_Results || "", "", // G:H
              item.PQR_OT_Remarks || "", "", "", "", "" // I:M
            ]);
            worksheet.mergeCells(`A${row.number}:D${row.number}`);
            worksheet.mergeCells(`E${row.number}:F${row.number}`);
            worksheet.mergeCells(`G${row.number}:H${row.number}`);
            worksheet.mergeCells(`I${row.number}:M${row.number}`);
            for (let c = 1; c <= 13; c++) {
              const cell = row.getCell(c);
              cell.alignment = { horizontal: 'center', vertical: 'middle' };
              cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
            }
          });
        }
      });

      // Remarks and Report Number — B:M merged
      const otRemarksRow2 = worksheet.addRow(["Remarks", headerData.PQR_OT_RemarksHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
      const otReportRow2 = worksheet.addRow(["Report Number", headerData.PQR_OT_ReportNumHorizontal || "", "", "", "", "", "", "", "", "", "", "", ""]);
      worksheet.mergeCells(`B${otRemarksRow2.number}:M${otRemarksRow2.number}`);
      worksheet.mergeCells(`B${otReportRow2.number}:M${otReportRow2.number}`);
      [otRemarksRow2, otReportRow2].forEach(row => {
        row.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        row.getCell(1).font = { bold: true };
        for (let c = 1; c <= 13; c++) {
          row.getCell(c).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
        }
      });

      worksheet.addRow([]); // Empty row
    }
    
    // CERTIFICATION section (for both Groove and Overlay)
    const certificationTitle2 = worksheet.addRow(["CERTIFICATION"]);
    certificationTitle2.getCell(1).font = { bold: true };
    certificationTitle2.getCell(1).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFE6E6FA' } };

    // Collect all lab ref numbers
    const labRefNumbers = [];
    excelData.pdfArray.forEach((pdfItem) => {
      if (pdfItem?.CertificationLabRef) {
        pdfItem.CertificationLabRef.forEach(item => {
          if (item.PQR_Certification_Lab_RefNo && item.PQR_Certification_Lab_RefNo.trim() !== "") {
            labRefNumbers.push(item.PQR_Certification_Lab_RefNo);
          }
        });
      }
    });

    // Header row: Welders Name | Id | Process | Tests conducted by + value | Laboratory ref. number label
    const certificationHeader2 = worksheet.addRow([
      "Welders Name", "", "Id", "", "Process", "", "", "Tests conducted by", "", headerData.PQR_Certification_ConductedBy || "", "", "", ""
    ]);
    worksheet.mergeCells(`A${certificationHeader2.number}:B${certificationHeader2.number}`);
    worksheet.mergeCells(`C${certificationHeader2.number}:D${certificationHeader2.number}`);
    worksheet.mergeCells(`E${certificationHeader2.number}:G${certificationHeader2.number}`);
    worksheet.mergeCells(`H${certificationHeader2.number}:I${certificationHeader2.number}`);
    worksheet.mergeCells(`J${certificationHeader2.number}:M${certificationHeader2.number}`);
    certificationHeader2.eachCell((cell, colNumber) => {
      if (colNumber === 1 || colNumber === 3 || colNumber === 5 || colNumber === 8) {
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        cell.font = { bold: true };
      }
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });

    // Welder data rows alongside lab ref values
    // First data row also carries the "Laboratory ref. number" label in H:M
    const allCertItems = [];
    excelData.pdfArray.forEach((pdfItem) => {
      if (pdfItem?.Certification) {
        pdfItem.Certification.forEach(item => allCertItems.push(item));
      }
    });

    const maxCertRows = Math.max(allCertItems.length, labRefNumbers.length, 1);
    for (let i = 0; i < maxCertRows; i++) {
      const cert = allCertItems[i] || {};
      const isFirstRow = i === 0;
      const refNo = isFirstRow ? "Laboratory ref. number" : (labRefNumbers[i - 1] || "");
      const isLabelRow = isFirstRow;
      const row = worksheet.addRow([
        cert.PQR_Certification_Welder_Name || "", "",
        cert.PQR_Certification_ID || "", "",
        cert.PQR_Certification_Process || "", "", "",
        refNo, "", "", "", "", ""
      ]);
      worksheet.mergeCells(`A${row.number}:B${row.number}`);
      worksheet.mergeCells(`C${row.number}:D${row.number}`);
      worksheet.mergeCells(`E${row.number}:G${row.number}`);
      worksheet.mergeCells(`H${row.number}:M${row.number}`);
      if (isLabelRow) {
        row.getCell(8).fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } };
        row.getCell(8).font = { bold: true };
      }
      for (let c = 1; c <= 13; c++) {
        row.getCell(c).alignment = { horizontal: 'center', vertical: 'middle' };
        row.getCell(c).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    }



    // Certification statement
    const certificationNoteRow = worksheet.addRow(["We certify that the statements in this record are correct and that the test welds were prepared, welded, and tested in accordance with the requirements of Section IX of the ASME Boiler and Pressure Vessel Code."]);
    worksheet.mergeCells(`A${certificationNoteRow.number}:M${certificationNoteRow.number}`);
    certificationNoteRow.getCell(1).font = { italic: true };
    certificationNoteRow.getCell(1).alignment = { horizontal: 'left', vertical: 'middle', wrapText: true };
    certificationNoteRow.height = 40;

    // SIGNATURE section — match reference R154-R157
    worksheet.addRow([]); // Empty row
    worksheet.addRow([]); // Empty row
    worksheet.addRow([]); // Empty row

    // R154: plain labels at A and G
    const sigHeaderRow = worksheet.addRow(["Welding Engineer", "", "", "", "", "", "Witness By", "", "", "", "", "", ""]);
    worksheet.mergeCells(`A${sigHeaderRow.number}:F${sigHeaderRow.number}`);
    worksheet.mergeCells(`G${sigHeaderRow.number}:M${sigHeaderRow.number}`);
    sigHeaderRow.getCell(1).font = { bold: true };
    sigHeaderRow.getCell(7).font = { bold: true };

    // R155: Name(A:C), Signature(D:F), Name(G:I), Signature(J:M)
    const sigNameRow = worksheet.addRow(["Name", "", "", "Signature", "", "", "Name", "", "", "Signature", "", "", ""]);
    worksheet.mergeCells(`A${sigNameRow.number}:C${sigNameRow.number}`);
    worksheet.mergeCells(`D${sigNameRow.number}:F${sigNameRow.number}`);
    worksheet.mergeCells(`G${sigNameRow.number}:I${sigNameRow.number}`);
    worksheet.mergeCells(`J${sigNameRow.number}:M${sigNameRow.number}`);
    for (let c = 1; c <= 13; c++) {
      const cell = sigNameRow.getCell(c);
      cell.alignment = { horizontal: 'left', vertical: 'middle' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    }

    // R156-R158: A:C and G:I per-row; D:F and J:M vertically merged (signature areas)
    const sigR127 = worksheet.addRow(["", "", "", "", "", "", "", "", "", "", "", "", ""]);
    const sigR128 = worksheet.addRow(["Date", "", "", "", "", "", "Date", "", "", "", "", "", ""]);
    const sigR129 = worksheet.addRow(["", "", "", "", "", "", "", "", "", "", "", "", ""]);

    worksheet.mergeCells(`D${sigR127.number}:F${sigR129.number}`);
    worksheet.mergeCells(`J${sigR127.number}:M${sigR129.number}`);

    [sigR127, sigR128, sigR129].forEach(row => {
      worksheet.mergeCells(`A${row.number}:C${row.number}`);
      worksheet.mergeCells(`G${row.number}:I${row.number}`);
      for (let c = 1; c <= 13; c++) {
        row.getCell(c).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      }
    });
    sigR128.getCell(1).alignment = { horizontal: 'left', vertical: 'middle' };
    sigR128.getCell(7).alignment = { horizontal: 'left', vertical: 'middle' };

    // Set print area dynamically to actual last row
    const lastRow = worksheet.lastRow.number;
    worksheet.pageSetup.printArea = `A1:M${lastRow}`;

    // Generate and download Excel file
    console.log('EXCEL: Generating Excel buffer');
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    const filename = `PQR_Report_${headerData.wld_WPSType}_${headerData.PQR_RecordNo || 'Export'}_${new Date().toISOString().split('T')[0]}.xlsx`;
    console.log('EXCEL: Generated filename:', filename);
    link.download = filename;
    link.click();
    window.URL.revokeObjectURL(url);
    console.log('EXCEL: Excel download completed');

    setLoading(false);
    props.onHide();
    console.log('EXCEL: generateExcel finished');
  }

  useEffect(() => {
    console.log('EXCEL: excelData useEffect triggered, header length:', excelData.header.length);
    if (excelData.header.length > 0) {
      console.log('EXCEL: Calling generateExcel');
      generateExcel();
    }
  }, [excelData]);

  return (
    <Modal
      {...props}
      size="sm"
      centered
      backdrop="static"
    >
      <Modal.Body style={{ maxHeight: "calc(10vh - 10px)" }}>
        <p>
          {loading && (
            <BarLoader
              color="blue"
              height={8}
              width={196}
              className="shift"
            />
          )}
        </p>
        <p style={{ textAlign: 'center', marginTop: '8px', marginBottom: '8px', fontSize: '14px' }}>Generating Excel file...</p>
      </Modal.Body>
    </Modal>
  );
};

export default Excel_DownloadPQR_GrooveOverlay;